<template>
  <div>
    <PageTable
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        :custCode="custCode"
        :destinationPort="destinationPort"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageTable from './table'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
export default {
  mixins: [BaseTable],
  props: {
    custCode: { type: String, default: '' },
    destinationPort: { type: String, default: '' },
  },
  components: { PageHeader, PageTable },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      request({
        url: '/master/shippingMark/list',
        method: 'post',
        data: {
          ...form,
          ...this.page,
        },
      })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      this.$refs.tableMain.choiceData()
    },
  },
}
</script>
